const Enums = {
    SortOrder: {
        None: "-1",
        Ascending: "0",
        Descending: "1"
    },
    ManageShippingAddresses: {
        None: "None",
        View: "View",
        Edit: "Edit", 
        Create: "Create",
        Full: "Full"
    },
    FieldType: {
        TextBox: 0,
        TextArea: 10,
        DropDown: 20,
        ListBox: 30,
        RadioButton: 50,
        DisplayList: 60
    },
    POFieldStatus: {
        NotUsed: 0,
        Optional: 10,
        Required: 20
    },
    PermissionLevel: {
        None: "None",
        View: "View",
        Edit: "Edit",
        Create: "Create",
        Full: "Full"
    },
    CCType: {
        "Visa": 1,
        "Mastercard": 2,
        "American Express": 3,
        "Discover": 4
    },
    BudgetType: {
        CostCenter: 0,
        UserConfig: 10,
        DeliveryAddress: 20
    },
    CheckOutResponseType: {
        CCAuthFailed: 0,
        SOCreated: 1,
        FailedToCreateSO: 2,
        NeedsApproval: 3,
        ApprovedNeedsApproval: 4,
        PreventCheckout: 5,
        Rejected: 6,
        AlreadyReviewed: 7,
        CurrentlyBeingReviewed: 8,
        EmptyCart: 9,
        CartNotSubmitted: 10,
        InvalidCoupon: 11
    },
    AmountPercent: {
        Amount: 0,
        Percent: 1
    },
    LoggedInStatus: {
        LoggedInAsUser: "Login as User"
    }
};

export default Enums;